import React from "react";
import ReactDOM from "react-dom";
import App from "./containers/App";
import * as serviceWorker from "./serviceWorker";
import { Reset } from "styled-reset";

import "./fonts/font.css";
import GlobalStyles from "./globalStyles";

ReactDOM.render(
  <div>
    <Reset></Reset>
    <GlobalStyles></GlobalStyles>
    <App></App>
  </div>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
